'use strict';
const core_1 = require("./core");
module.exports = core_1.findWorkspaceRoot;
//# sourceMappingURL=index.js.map